module.exports = __webpack_public_path__ + "static/media/muslin.1f3a7d2b.jpg";